import React, { Component } from "react";
import { connect } from "react-redux";

import ComponentSelector from "../utils/components/ComponentSelector";
import MyEVs from "./MyEVs";
import OtherEVs from "./OtherEVs";
import Drivers from "./Drivers";
import Cards from "./Cards";

class EVs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="evs" className="evio-container sidebar-fix main-component">
        {this.props.brand?.brandName === "EVIO" ? (
          <ComponentSelector
            tabs={[
              { title: "label_myEVs", component: <MyEVs /> },
              { title: "evs_drivers", component: <Drivers /> },
              { title: "contracts_newTitle", component: <Cards /> },
            ]}
          />
        ) : (
          <ComponentSelector
            tabs={[
              { title: "label_myEVs", component: <MyEVs /> },
              {
                title: "evs_otherEVs",
                component: <OtherEVs />,
              },
              { title: "evs_drivers", component: <Drivers /> },
              { title: "contracts_newTitle", component: <Cards /> },
            ]}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(EVs);
